<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="hide">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header pr-0">
        <div class="sub-heading" style="margin: 0;"><h5 style="color : #002F42">{{ pathwayName }}</h5></div>
        <button type="button" class="close mr-0 pr-0" data-dismiss="modal" @click="hide">&times;</button>
      </div>
      <div class="modal-body">
        <div class="modal-body- modal_add_rep d-none- mb-3" style="">


          
          <div class="row">
            <div class="col-5 p-0" style="padding-left: 12px !important;">
              <div class="h6 mb-0" style="margin-top: 0px !important;">History</div>
            </div>
            <div class="col-6 p-0">
                <div class="col-12 float-left" style="padding-right: 18px !important;">
                  <div class="cp-filter-label col-4 p-0 float-left" style="margin-top: 0px;">Date Range:</div>
                  <b-form-select v-model="rep_days" 
                  @change="getLogs()"
                  :options="itemSource2" style="margin-bottom: 10px !important; margin-top: -8px;" class="col-8 float-left" />
                </div>
            </div>
            <div class="col-1 pr-0">
              <div v-if="logs.length > 0" style="margin-left: 15px; margin-top: 3px; float: right; margin-right: 0px; margin-top: 2px;" @click="downloadFunc()">
                <img v-if="logs.length > 0"  class="" src="@/assets/Download_Report.svg" alt="MentorMentee" width="22px" style="cursor: pointer;" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col p-0" style="padding-left: 14px !important;">
              <div class="mt-3 mb-2" v-for="(log, index) in logs" :key="index">
                <div class="col p-0">
                  <div class="row m-0 pb-2 border-bottom">
                    <div class="col-9 pl-0">
                      <div class="mb-0">{{ log.title }}</div>
                      <div class="small text-muted mb-0">{{ log.description }}</div>
                    </div>
                    <div class="col-3 pr-0 small text-right text-muted">{{ log.createdAtFormatted }}</div>
                  </div>
                </div>
              </div>
                    
                    

                    <div class="row" v-if="logs.length == 0 && loading == false">
                      <div class="col p-0"  style="padding-left: 14px !important;">
                        <div>No logs found.</div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

            </div>
            <div class="modal-footer"></div>
            </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import axios from 'axios';
import router from '../../router/index.js';

export default {
  props: ['isModalVisible'],
  data() {
    return {
      logs: [],
      pathwayId: '',
      accountId: '',
      apiUrl: '',
      loading: false,
      pathwayName: '',
      itemSource2: [
          { value: "", text: "Select Date Range" }, 
          { value: "7", text: "Last 7 days" }, 
          { value: "15", text: "Last 15 days" },
          { value: "30", text: "Last 30 days" },
          { value: "180", text: "Last 6 Months" },
          { value: "All", text: "All Time" }
      ],
      rep_days: 7,
    }
  },
  computed: {
    
  },
  methods: {
    hide() {
      this.$emit('closeLogFullListModal');
    },
    getActivityData(pathwayId, accountId) {
      this.pathwayId = pathwayId;
      this.accountId = accountId;
      this.rep_days = 7;
      this.logs = [];
      this.getLogs();  
    },
    downloadFunc: function() {

      const params = {};
      if (this.rep_days) {
          params.days = this.rep_days;
      } else {
          params.days = '';
      }
      params.pathwayId = this.pathwayId;
      axios('/desktop/v2/get-pathway-log/full-list-pdf', {
        method: 'GET',
        params: params
      })
      .then(response =>  {
          this.pdf_file_name = response.data.pdf_file_name;
          var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
     
          //Create XMLHTTP Request.
          var req = new XMLHttpRequest();
          req.open("GET", url, true);
          req.responseType = "blob";
          req.onload = function () {
              //Convert the Byte Data to BLOB object.
              var blob = new Blob([req.response], { type: "application/octetstream" });

              //Check the Browser type and download the File.
              var isIE = false || !!document.documentMode;
              if (isIE) {
                  window.navigator.msSaveBlob(blob, fileName);
              } else {
                  var url = window.URL || window.webkitURL;
                  var link = url.createObjectURL(blob);
                  var a = document.createElement("a");
                  a.setAttribute("download", "pathway_audit_log.pdf");
                  a.setAttribute("href", link);
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
              }
          };
          req.send();
          return false;
        })
        .catch(function(error) {
            console.log(error);
        });


    },

    getLogs() {
      this.logs = [];
      this.loading = true;
      const params = {};
      if (this.rep_days) {
          params.days = this.rep_days;
      } else {
          params.days = '';
      }
      params.pathwayId = this.pathwayId;
      axios.get('/desktop/v2/get-pathway-log/full-list', {
        params: params
      })
      .then(response =>  {
        let data = response.data;
        this.loading = false;
        this.pathwayName = data.pathwayName;
        this.logs = this.logs.concat(data.logs);
      })
      .catch(function() {});
    },
  },
  components: {
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}

a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}

.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    width: 800px;
    height: 450px;
    overflow-y: scroll;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
}
.modal-body {
    margin: 0px;
    padding: 10px;
}
@media(max-width:560px) {
  .modal-container {
    width: 98%;
    padding: 20px 20px;
  }
  .modal-body {
      margin: 0px;
      padding: 0px;
  }
}

.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -1.75rem -1rem auto;
  font-size: 30px;
}
.modal-footer {
  border-top: none;
}

</style>


// WEBPACK FOOTER //
// src/components/admin/master_admin_pathway_catalog_audit_log_full_list.vue